export const environment = {
    production: true,
    api: 'https://feature42803.api.classichub.co.nz',
    buildVersion: '2026.10.8.4',
    uri: 'https://feature42803.classichub.co.nz',
    envName: 'feature42803',
    isTest: true,
};

